module.exports = __webpack_public_path__ + "img/swiper3.fe78e289.png";